import { RefreshCw } from 'lucide-react'
import * as React from 'react'

import { Button } from '@/components/ui/button'
import { useServiceWorkerUpdate } from '@/lib/pwa'

/**
 * Aviso de versão nova do Hub (Onda 6.2). Fica no topo, e não no canto dos
 * toasts: no celular o rodapé é da barra de navegação, e o aviso não pode
 * sumir sozinho como um toast — ele espera a pessoa decidir.
 */
export function UpdatePrompt() {
  const { needRefresh, update, dismiss } = useServiceWorkerUpdate()
  if (!needRefresh) return null
  return <UpdateBanner onUpdate={update} onDismiss={dismiss} />
}

export function UpdateBanner({
  onUpdate,
  onDismiss,
}: {
  onUpdate: () => void
  onDismiss: () => void
}) {
  const [updating, setUpdating] = React.useState(false)
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-3 top-3 z-[60] mx-auto flex max-w-md flex-wrap items-center gap-3 rounded-md border border-border bg-card p-3 text-foreground shadow-lg sm:flex-nowrap"
    >
      <div className="flex min-w-0 flex-1 items-start gap-2.5">
        <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
        <div className="min-w-0">
          <p className="text-[13px] font-medium">Nova versão disponível</p>
          <p className="text-[12px] text-muted-foreground">
            Atualize para carregar a versão nova do Hub.
          </p>
        </div>
      </div>
      <div className="ml-auto flex shrink-0 gap-2">
        <Button
          variant="ghost"
          className="h-11 md:h-8"
          onClick={onDismiss}
          disabled={updating}
        >
          Agora não
        </Button>
        <Button
          className="h-11 md:h-8"
          onClick={() => {
            setUpdating(true)
            onUpdate()
          }}
          disabled={updating}
        >
          {updating ? 'Atualizando...' : 'Atualizar'}
        </Button>
      </div>
    </div>
  )
}
